export const AppConfig = {
  axios: {
    saas_endpoint:
      import.meta.env.VITE_SAAS_ENDPOINT ||
      'https://api.staging.qanda-assist.com',
    llm_endpoint:
      import.meta.env.VITE_LLM_ENDPOINT ||
      'https://api.staging.qanda-assist.com/llm',
    timeout: 600000,
  },
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN || 'prod-qa-assist.jp.auth0.com',
    clientId:
      import.meta.env.VITE_AUTH0_CLIENT_ID ||
      'KFII3oRwNQ7iZ4QQRRE8eDPtWzLMIeaZ',
    authorizationParams: {
      redirect_uri:
        import.meta.env.VITE_AUTH0_REDIRECT_URI ||
        'https://staging.qanda-assist.com/',
      audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
    },
  },
};
